import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useInView } from 'framer-motion';

const Testimonials = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1.5 } },
  };

  return (
    <section ref={ref} className="padding bg-gray-100 w-full">
      <div className="text-center mb-8">
        <h2 className="text-4xl font-bold mb-6 text-blue-600">What Our Students Say</h2>
        <motion.div
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.2, // Stagger fade for each block
              },
            },
          }}
          className="flex flex-wrap justify-center"
        >
          <motion.blockquote
            variants={fadeInVariants}
            className="border-l-4 border-blue-500 pl-4 mb-6 mx-4 max-w-sm bg-white shadow-lg rounded-lg p-4 transition-transform duration-300"
          >
            <p className="italic">
              "This institute changed my life! The faculty is amazing and the support is unbeatable."
            </p>
            <cite className="block mt-2 text-right font-semibold">- Student 1</cite>
          </motion.blockquote>

          <motion.blockquote
            variants={fadeInVariants}
            className="border-l-4 border-blue-500 pl-4 mb-6 mx-4 max-w-sm bg-white shadow-lg rounded-lg p-4 transition-transform duration-300"
          >
            <p className="italic">
              "The courses are well-structured and really helped me understand the concepts."
            </p>
            <cite className="block mt-2 text-right font-semibold">- Student 2</cite>
          </motion.blockquote>

          <motion.blockquote
            variants={fadeInVariants}
            className="border-l-4 border-blue-500 pl-4 mb-6 mx-4 max-w-sm bg-white shadow-lg rounded-lg p-4 transition-transform duration-300"
          >
            <p className="italic">
              "I gained the skills I needed to succeed in my career, thanks to the hands-on approach."
            </p>
            <cite className="block mt-2 text-right font-semibold">- Student 3</cite>
          </motion.blockquote>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
